export const authorizePartnersAccess = [
  'Josh Gibson',
  'Allon Rodin',
  'Michael Burr',
  'Justin Chalk',
  'Tanner Draper',
  'William Penn',
  'Shruthi Shangar',
  'Demo Automation'
];
